export default __webpack_public_path__ + "static/media/FontAwesome5_Pro_Regular.4b35e208.ttf";